import React from 'react';
import { Award, Users, Truck, CheckCircle } from 'lucide-react';
import { businessInfo } from '../mockData';

const AboutPage = () => {
  return (
    <div className="about-page">
      <section className="page-hero">
        <div className="page-hero-content">
          <h1 className="page-hero-title">About Drip Audio LLC</h1>
          <p className="page-hero-subtitle">
            Your trusted mobile car audio installation experts in Metro Atlanta
          </p>
        </div>
      </section>

      <section className="about-story-section">
        <div className="about-story-content">
          <div className="about-story-image">
            <img
              src="https://images.unsplash.com/photo-1592570714618-15e2d4719c6c"
              alt="Professional car audio installation"
            />
          </div>
          <div className="about-story-text">
            <h2 className="story-title">Our Story</h2>
            <p className="story-paragraph">
              Drip Audio LLC is a premier mobile car stereo installation service
              based in Forest Park, Georgia. We bring professional car audio
              expertise directly to your location, whether it's your home,
              workplace, or anywhere in Metro Atlanta.
            </p>
            <p className="story-paragraph">
              With years of experience in car audio systems, we specialize in
              high-quality installations, upgrades, and troubleshooting. Our
              mission is to provide convenient, professional service that
              transforms your driving experience with superior sound quality.
            </p>
            <p className="story-paragraph">
              We pride ourselves on our 5-star Google rating and the trust our
              customers place in us. Every installation is performed with
              precision, care, and a commitment to excellence that sets us apart.
            </p>
          </div>
        </div>
      </section>

      <section className="about-values-section">
        <h2 className="section-title">What Sets Us Apart</h2>
        <div className="values-grid">
          <div className="value-card">
            <div className="value-icon">
              <Truck size={40} />
            </div>
            <h3 className="value-title">Mobile Convenience</h3>
            <p className="value-description">
              We come to you, saving you time and hassle. No need to visit a
              shop or wait around - we bring the expertise to your location.
            </p>
          </div>
          <div className="value-card">
            <div className="value-icon">
              <Award size={40} />
            </div>
            <h3 className="value-title">Expert Craftsmanship</h3>
            <p className="value-description">
              Top-notch installation work with attention to every detail. We use
              professional techniques to ensure perfect integration and sound.
            </p>
          </div>
          <div className="value-card">
            <div className="value-icon">
              <Users size={40} />
            </div>
            <h3 className="value-title">Customer Focused</h3>
            <p className="value-description">
              Your satisfaction is our priority. We listen to your needs and
              deliver solutions that exceed expectations every time.
            </p>
          </div>
          <div className="value-card">
            <div className="value-icon">
              <CheckCircle size={40} />
            </div>
            <h3 className="value-title">Reliable Service</h3>
            <p className="value-description">
              Efficient, on-time service you can count on. We respect your time
              and deliver professional results without delays.
            </p>
          </div>
        </div>
      </section>

      <section className="about-coverage-section">
        <div className="coverage-content">
          <h2 className="coverage-title">Service Coverage</h2>
          <p className="coverage-description">
            Based in {businessInfo.location}, we proudly serve customers
            throughout Metro Atlanta and surrounding areas.
          </p>
          <div className="coverage-areas">
            {businessInfo.serviceArea.map((area, index) => (
              <div key={index} className="coverage-area-item">
                <CheckCircle size={20} />
                <span>{area}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;